import { render } from "./DishCardInOrder.vue?vue&type=template&id=512307d2&lang=pug"
import script from "./DishCardInOrder.vue?vue&type=script&setup=true&lang=js"
export * from "./DishCardInOrder.vue?vue&type=script&setup=true&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__